<script lang="ts">
export default {
  name: 'ColorSwatch',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { XCircle } from 'lucide-vue-next';

const props = defineProps<{
  color: string;
  small?: boolean;
  rounded?: boolean;
  modelValue?: string;
  selected?: boolean;
  editable?: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
  remove: [value: string];
}>();

const btnSize = computed(() => {
  return props.small ? '22px' : '28px';
});

const outlineSize = computed(() => {
  return props.small ? 'tw:w-[26px] tw:h-[26px]' : 'tw:w-[32px] tw:h-[32px]';
});

const lgRound = computed(() => {
  return props.rounded ? '-lg' : '';
});

function handleClick(): void {
  emit('update:modelValue', props.color);
}

function handleRemove(): void {
  emit('remove', props.color);
}
</script>

<template>
  <div
    class="tw:relative tw:flex tw:items-center tw:justify-center tw:border tw:border-solid tw:p-0 tw:hover:border-gray-400"
    :class="`tw:rounded${lgRound} ${outlineSize} tw:border-${selected ? 'black' : 'transparent'} `"
  >
    <v-btn
      :class="`tw:p-0 tw:rounded${lgRound} 
      tw:outline tw:outline-1 tw:outline-gray-400 tw:hover:outline-transparent`"
      :width="btnSize"
      :min-width="btnSize"
      :height="btnSize"
      :color="color"
      elevation="0"
      @click="handleClick"
    />

    <XCircle
      v-if="editable"
      @click.stop="handleRemove"
      :size="20"
      class="tw:absolute tw:left-4 tw:top-[-10px] tw:m-0 tw:scale-[60%] tw:cursor-pointer tw:rounded-full tw:bg-taupe tw:p-0 tw:transition-all tw:hover:scale-[80%]"
    />
  </div>
</template>
